import { render, staticRenderFns } from "./PifInfos.vue?vue&type=template&id=225c0f19&scoped=true"
import script from "./PifInfos.vue?vue&type=script&lang=js"
export * from "./PifInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225c0f19",
  null
  
)

export default component.exports